<!-- TikTok Message -->
<ng-container *ngIf="pages?.[0]?.platform?.toLowerCase().includes('tiktok'); else notTiktokTrends">
  <div class="bg-white border border-gray-200 rounded-xl p-8">
    <div class="flex h-[320px] w-full flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-gray-200 bg-gray-50/70 p-6 text-center">
      <div>
        <p class="mb-1 text-sm font-semibold text-gray-500">
          TikTok analytics are not available yet.
        </p>
        <p class="text-xs text-gray-400">
          We're working on bringing you TikTok insights soon.
        </p>
      </div>
    </div>
  </div>
</ng-container>

<!-- Non-TikTok Content -->
<ng-template #notTiktokTrends>
  <div class="bg-white border border-gray-200 rounded-xl">

    <!-- Tabs -->
    <div class="grid grid-cols-3 border-b border-gray-200">

      <!-- Loop tabs -->
      <ng-container *ngFor="let tab of tabs">

        <!-- Only allow Reach tab if Instagram -->
        <button
          *ngIf="!isInstagram || tab.key === 'reach'"
          (click)="setActiveTab(tab.key)"
          class="cursor-pointer py-2.5 text-sm font-medium transition-all border-r border-gray-200
                 first:rounded-tl-xl last:rounded-tr-xl text-center w-full"
          [ngClass]="
            activeTab === tab.key
              ? 'bg-gray-600 text-white'
              : 'bg-white text-black hover:bg-gray-50 hover:text-gray-600'
          "
        >
          {{ tab.label }}
        </button>

      </ng-container>

    </div>

    <!-- Chart body -->
    <div class="p-2 lg:p-6 lg:pt-8 lg:pb-8">
      <ng-container [ngSwitch]="activeTab">

        <!-- REACH -->
        <app-social-ai-reach-chart
          *ngSwitchCase="'reach'"
          [selectedSiteId]="selectedSiteId"
          [selectedPlatformId]="selectedPlatformId"
          [selectedPeriod]="selectedPeriod"
          [pages]="pages">
        </app-social-ai-reach-chart>

        <!-- IMPRESSIONS -->
        <app-social-ai-impressions-chart
          *ngSwitchCase="'impressions'"
          [selectedSiteId]="selectedSiteId"
          [selectedPlatformId]="selectedPlatformId"
          [selectedPeriod]="selectedPeriod"
          [pages]="pages">
        </app-social-ai-impressions-chart>

        <!-- ENGAGEMENT -->
        <app-social-ai-engagement-chart
          *ngSwitchCase="'engagement'"
          [selectedSiteId]="selectedSiteId"
          [selectedPlatformId]="selectedPlatformId"
          [selectedPeriod]="selectedPeriod"
          [pages]="pages">
        </app-social-ai-engagement-chart>

      </ng-container>
    </div>

  </div>
</ng-template>
